<template>
  <div class="page-dashboard">

    <resize-observer @notify="__resizeHandler"/>

    <el-row class="mt-0 mb-20" :gutter="30">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <activity-plot
          ref="dashboardPlot"
          direction="IN"
          name="Call Report"
          :branchOptions="[]"
          :allowFilter="false"
        />
      </el-col>
    </el-row>

    <el-row class="mt-0" :gutter="30">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="success-text" sprite="checkbox"/>
                  System Status
                </h2>
              </div>
            </div>
            <div class="system-status">
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">Fax</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">Features</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">Mobile</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">SMS</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">Voice</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
              <div class="status-wrapper">
                <div class="system-status-group">
                  <span class="black-text">PSTN</span>
                  <v-svg class="voxo-green" sprite="check-circle-negative"></v-svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="voxo-yellow" sprite="group-2"/>
                  Users
                </h2>
                <h1 class="text-truncate voxo-yellow text-center">{{userCount}}</h1>
                <h4 class="black-text text-center">Users</h4>
                <div class="dashboard-button">
                  <router-link to="/users">
                    <el-button>
                      <div class="dashboard-button-group">
                        <v-svg class="voxo-yellow" sprite="group-2"></v-svg>
                        <span>View All Users</span>
                      </div>
                    </el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="success-text" sprite="telephone"/>
                  Extensions
                </h2>
                <h1 class="m-0 text-truncate voxo-green text-center">{{extCount}}</h1>
                <h4 class="black-text text-center">Extensions</h4>
                <div class="dashboard-button">
                  <router-link to="/extensions">
                    <el-button>
                      <div class="dashboard-button-group">
                        <v-svg class="voxo-green" sprite="telephone"></v-svg>
                        <span>View All Extensions</span>
                      </div>
                    </el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="mt-0" :gutter="30">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="voxo-aqua" sprite="call-forward"/>
                  Port Your Number
                </h2>
                <h2 class="m-0 text-truncate voxo-green text-center"><span
                  class="black-text font-size-15 font-weight-400">Transfer your existing numbers to {{themeName}}</span></h2>
                <div class="dashboard-button">
                  <router-link to="/number-porting?context=create">
                    <el-button>
                      <div class="dashboard-button-group">
                        <v-svg class="voxo-aqua" sprite="call-forward"></v-svg>
                        <span>Create Request</span>
                      </div>
                    </el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">

          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="voxo-pink" sprite="phone-number"/>
                  Phone Numbers
                </h2>
                <h1 class="m-0 text-truncate voxo-pink text-center">{{didsCount}}</h1>
                <h4 class="black-text text-center">Numbers</h4>
                <div class="dashboard-button">
                  <router-link to="/phone-numbers?context=create">
                    <el-button>
                      <div class="dashboard-button-group">
                        <v-svg class="voxo-pink" sprite="phone-number"></v-svg>
                        <span>New Number</span>
                      </div>
                    </el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20 pt-10">
            <div class="flex justify-center align-center">
              <div v-if="!whiteLabel" class="widget-info box grow text-truncate animated fadeInLeft">
                <h2 class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center">
                  <v-svg class="voxo-red" sprite="message"/>
                  Get Help
                </h2>
                <h2 class="m-0 text-truncate voxo-pink text-center"><span
                  class="black-text font-size-15 font-weight-400">Get help with frequently asked questions</span></h2>
                <div class="dashboard-button">
                  <div @click="toggleIntercom">
                  <el-button>
                    <div class="dashboard-button-group">
                      <v-svg class="voxo-red" sprite="message"></v-svg>
                      <span>Get Support</span>
                    </div>
                  </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

  import feathersClient from '../../../feathers/feathers-client';
  import ActivityPlot from './components/activity-plot';
  import {isWhiteLabel} from "@/globals/globals";

  export default {
    name: 'Dashboard',
    components: {ActivityPlot},
    data() {
      return {
        didsCount: '',
        extCount: '',
        userCount: '',
        chartLoading: false,
        resized: false,
        enableIntercom: true
      }
    },
    computed: {
      whiteLabel() {
        return isWhiteLabel();
      },
      user() {
        return this.$store.state.auth.user;
      },
      selectedTenant() {
        return this.$store.state.selectedTenant;
      },
      themeName(){
        return this.$store.state.branding.themeName;
      }
    },
    watch: {
      user() {
        this.updateCounts()
      },
      selectedTenant() {
        this.updateCounts();
      }
    },
    methods: {
      toggleIntercom() {
        this.enableIntercom = !this.enableIntercom;
        this.enableIntercom ? this.hideIntercom() : this.showIntercom();
      },
      hideIntercom() {
        window.Intercom("hide");
      },
      showIntercom() {
        window.Intercom("show");
      },
        updateCounts() {
        feathersClient.service('tenants').get(this.selectedTenant.id).then( res => {
          this.extCount = res.extensionsCount;
          this.didsCount = res.didsCount;
          this.userCount = res.usersCount;
        });
      },
      __resizeHandler: _.throttle(function (e) {
        if (this.resized) {
          setTimeout(() => {
            this.$refs.dashboardPlot.chart.resize();
          }, 1000)
        }
        this.resized = true
      }, 700),
    },
    mounted() {
      window.Intercom("onHide", () => {
        this.enableIntercom = true;
      });
      if (this.user) {
        this.updateCounts();
      }
    },
    beforeDestroy(){
      this.$refs.dashboardPlot.$destroy();
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/variables';

  .page-dashboard {
    overflow: auto;

    .card-base {

      h1 {
        font-weight: 900;
      }

      h2 {
        svg {
          width: 25px;
          height: 25px;
          padding-right: 6px;
        }
      }
    }
  }

  .widget-info {
    h1, h4 {
      margin: 0px;
    }

    h1 {
      font-size: 3em;
    }

  }

  .dashboard-button-group {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      padding-left: 10px;
    }
  }

  .dashboard-button {
    text-align: center;
    padding: 18px;
  }

  .system-status {
    display: flex;
    flex-wrap: wrap;

    > * {
      flex-basis: 50%;
    }
  }

  .system-status-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
    padding-bottom: 3px;
    border-bottom: 1px solid lightgray;
  }

  .widget {
    height: 250px;
    position: relative;

    .widget-header {

      .widget-icon-box {
        background: rgba(0, 0, 0, .02);
        border: 1px solid rgba(0, 0, 0, .02);
        border-radius: 4px;
        text-align: center;
        width: 60px;
        padding: 5px;
      }

      .widget-title {
        font-weight: 700;
        border-bottom: 1px solid lightgrey;
      }
    }


    .badge-box {
      .badge {
        display: inline-block;
        border-radius: 4px;
        font-size: 80%;
      }
    }
  }

  .timeline {
    max-width: 1200px;
    margin: 6px;
  }

  .timeline, .timeline-title {
    color: $text-color;
    line-height: 1.4;
    cursor: default;
    font-family: inherit;
  }

  @media (min-width: 768px) and (max-width: 1040px) {
    .radio-switcher {
      display: none;
    }

    .widget {
      .widget-header {
        .widget-icon-box {
          display: none;
        }
      }
    }
  }

  @media (max-width: 420px) {
    .radio-switcher {
      display: none;
    }

  }
</style>

<style lang="scss">
  .page-dashboard {

    .widget {
      .peity {
        position: absolute;
        bottom: -1px;
        left: 0;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }

    table.styled {
      .peity {
        margin-right: 10px;
      }
    }

    .vb-content {
      padding: 0 20px;
      box-sizing: border-box !important;
      margin-top: -5px;
      margin-left: -20px;
      margin-right: -20px;
      height: calc(100% + 15px) !important;
      width: calc(100% + 40px) !important;
    }
  }

  @media (max-width: 768px) {
    .page-dashboard {
      .vb-content {
        padding: 0 5px !important;
        margin: -5px;
        width: calc(100% + 10px) !important;
      }
    }
  }
</style>


